@import '^scss-config';

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  width: 100%;
  height: 100%;

  padding: 5.625rem 0;

  @include desktop {
    padding: 7.75rem 0;
  }
}
